import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  DASHBOARD_DELETE_COACH_CALL_BEGIN,
  DASHBOARD_DELETE_COACH_CALL_SUCCESS,
  DASHBOARD_DELETE_COACH_CALL_FAILURE,
  DASHBOARD_DELETE_COACH_CALL_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function deleteCoachCall(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: DASHBOARD_DELETE_COACH_CALL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${config.apiRootUrl}/upcoming-calls/${args.callId}/` + (args.userId ? `?user_id=${args.userId}` : ''),
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DASHBOARD_DELETE_COACH_CALL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: DASHBOARD_DELETE_COACH_CALL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCoachCallError() {
  return {
    type: DASHBOARD_DELETE_COACH_CALL_DISMISS_ERROR,
  };
}

export function useDeleteCoachCall() {
  const dispatch = useDispatch();

  const { deleteCoachCallPending, deleteCoachCallError } = useSelector(
    (state) => ({
      deleteCoachCallPending: state.dashboard.deleteCoachCallPending,
      deleteCoachCallError: state.dashboard.deleteCoachCallError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(deleteCoachCall(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissDeleteCoachCallError());
  }, [dispatch]);

  return {
    deleteCoachCall: boundAction,
    deleteCoachCallPending,
    deleteCoachCallError,
    dismissDeleteCoachCallError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DASHBOARD_DELETE_COACH_CALL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteCoachCallPending: true,
        deleteCoachCallError: null,
      };

    case DASHBOARD_DELETE_COACH_CALL_SUCCESS:
      // The request is success
      return {
        ...state,
        deleteCoachCallPending: false,
        deleteCoachCallError: null,
      };

    case DASHBOARD_DELETE_COACH_CALL_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteCoachCallPending: false,
        deleteCoachCallError: action.data.error,
      };

    case DASHBOARD_DELETE_COACH_CALL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteCoachCallError: null,
      };

    default:
      return state;
  }
}
